import Typography from "@mui/material/Typography";

import BillingLinkButton from "@app/analytics/account/Billing/components/BillingLinkButton";
import { isFreePlan } from "@app/analytics/account/Billing/utils";
import useBillingContext from "@app/analytics/hooks/billing/useBillingContext";
import ROUTES from "@app/common/routes";
import type { Client } from "@app/common/types";

import Link from "@rui/Link";
import { Row } from "@rui/Stack";

const AdminCurrentPlanActions = ({ client }: { client: Client }) => {
  const { currentPlan, isTrial } = useBillingContext();

  return (
    <>
      {client === "zoom" ? (
        <Typography>
          To manage your billing information,{" "}
          <Link href={ROUTES.BILLING} sx={{ fontWeight: 500 }}>
            open in the browser
          </Link>
          .
        </Typography>
      ) : (
        <Row spacing={1}>
          <BillingLinkButton
            to={ROUTES.BILLING_COMPARE_PLANS}
            testId="billing-change-plan-button"
          >
            {isTrial
              ? "Select plan"
              : isFreePlan(currentPlan.type)
                ? "Upgrade plan"
                : "Change plan"}
          </BillingLinkButton>
        </Row>
      )}
    </>
  );
};

export default AdminCurrentPlanActions;
